import {api} from '@/libs/baseApi.client';

export interface AirdropShareResponse {
  reward: {
    poe: number;
    coins: number;
  };
  shareContent: {
    totalAmountUsd: number;
    shareText: string;
    earnLink: string;
  };
}

/**
 * Complete Airdrop Card action: share the total value of tokens rewarded last week.
 * One-time per week. POST /api/competitions/airdrop-share, no parameters.
 */
export const shareAirdrop = async (): Promise<AirdropShareResponse> => {
  const response = await api.post<AirdropShareResponse>('/competitions/airdrop-share');
  return response.data;
};
